import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-3"
}
const _hoisted_2 = { class: "mt-5 text-center text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvoiceDetailsTable = _resolveComponent("InvoiceDetailsTable")!
  const _component_InvoiceDealDetailsTable = _resolveComponent("InvoiceDealDetailsTable")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      (_ctx.invoice)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_InvoiceDetailsTable, { invoice: _ctx.invoice }, null, 8, ["invoice"]),
            _createElementVNode("div", null, [
              _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.helper.trans("labels.invoice_deals")), 1),
              _createVNode(_component_InvoiceDealDetailsTable, {
                deals: _ctx.deals.items
              }, null, 8, ["deals"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}